import React from 'react'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import ControlledModal from '../../../components/modals/ControlledModal'
import CreateTemplateRecordForm from './CreateTemplateRecordForm'
import Line from '../../../packages/kiti/components/helpers/Line'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const CreateTemplateRecordModal = props => {
  return (
    <ControlledModal width="26rem" {...props}>
      <Title size="h5" bold>
        Gerando PDF
      </Title>
      <Line />
      <Separator weight={4} />

      <CreateTemplateRecordForm />
    </ControlledModal>
  )
}

export default CreateTemplateRecordModal
